<template>
	<div v-if="slidesList.length">
		<agile :options="agileOptions" ref="carousel" :key="slidesList.length" class="">
			<!-- <template slot="prevButton"><font-awesome-icon icon="fa-solid fa-chevron-left" /></template>
			<template slot="nextButton"><font-awesome-icon icon="fa-solid fa-chevron-right" /></template> -->

			<router-link
				v-for="(slide, index) in slidesList"
				:key="index"
				:to="'/events/' + slide.shortId"
				class="slide border rounded"
			>
				<img :src="slide.sliderImageBig" :alt="slide.title" :title="slide.title" class="full" />
				<img :src="slide.sliderImageMin" :alt="slide.title" :title="slide.title" class="mobile" />

				<div class="carousel-caption d-block">
					<template v-if="!slide.hideTextInSlider">
						<h4 class="name">{{ slide.title }}</h4>
						<p class="period">
							<span>{{ slide.dateStart | moment("DD.MM.YYYY") }}</span>
							<template v-if="slide.dateEnd">
								<span v-if="moment(slide.dateEnd).format('DD.MM.YYYY') != moment(slide.dateStart).format('DD.MM.YYYY')">
									&nbsp;—&nbsp;{{ slide.dateEnd | moment("DD.MM.YYYY") }}</span
								>
							</template>
						</p>
					</template>
				</div>
			</router-link>
		</agile>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueAgile } from "vue-agile";
export default {
	components: { agile: VueAgile },
	data() {
		return {
			agileOptions: {
				navButtons: true,
				autoplay: false,
				autoplaySpeed: 6000,
				fade: true,
				pauseOnHover: true,
				pauseOnDotsHover: true,
				slidesToShow: 1,
				infinite: true,

				responsive: [
					{
						breakpoint: 300,
						settings: {
							dots: true,
							navButtons: false,
						},
					},

					{
						breakpoint: 900,
						settings: {
							navButtons: true,
							dots: true,
						},
					},
				],
			},
		};
	},
	computed: {
		...mapGetters({
			slidesList: "params/GET_MAIN_SLIDES",
			getEventType: "params/GET_EVENT_TYPE",
		}),
	},
	methods: {
		getImageUrl(imageId) {
			return `https://picsum.photos/850/240/?image=${imageId}`;
		},
		buttonType(id) {
			return this.getEventType(id).joinText;
		},
	},
	mounted() {
		// this.$refs.carousel.reload();
	},
	async created() {
		await this.$store.dispatch("params/getSlides");
	},
};
</script>

<style>
.slide {
	position: relative;
	overflow: hidden;
}

.slide > img {
	width: 100%;
	margin: 0 auto;
}

@media (min-width: 569px) {
	.slide > img {
		max-height: 400px;
		max-width: 1270px;
		display: block;
	}
	.slide > img.mobile {
		display: none;
	}
}

@media (max-width: 568px) {
	.slide > img {
		max-height: 210px;
		max-width: 320px;
		display: block;
	}
	.slide > img.full {
		display: none;
	}
}

.carousel-caption {
	bottom: 0.15rem;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
	.slide {
		overflow: visible;
	}

	.carousel-caption {
		padding-top: 0;
		padding-bottom: 0;
		right: 5%;
		left: 5%;
		overflow: visible;
	}
	.carousel-caption h4 {
		font-size: 1rem;
		text-shadow: 5px 5px 5px #333333;
	}
	.carousel-caption .period {
		font-size: 0.5rem;
		text-shadow: 5px 5px 5px #333333;
	}
	.agile__actions {
		margin-top: 1rem;
	}
}

.slide .carousel-caption .name,
.slide .carousel-caption .title,
.slide .carousel-caption .period {
	color: #fff;
	text-shadow: 5px 5px 5px #333333;
}
.agile__actions {
	/* margin-top: 20px; */
	justify-content: center;
}
.agile__nav-button {
	background: transparent;
	border: none;
	color: #ccc;
	cursor: pointer;
	font-size: 24px;
	transition-duration: 0.3s;
}
.agile__nav-button:hover {
	color: #888;
}
.agile__dots {
	padding-left: 0 !important;
	margin-bottom: 0;
}
.agile__dot {
	margin: 0 10px;
}
.agile__dot button {
	background-color: #eee;
	border: none;
	border-radius: 50%;
	cursor: pointer;
	display: block;
	height: 10px;
	font-size: 0;
	line-height: 0;
	margin: 0;
	padding: 0;
	transition-duration: 0.3s;
	width: 10px;
}
.agile__dot--current button,
.agile__dot:hover button {
	background-color: #888;
}
</style>
